import { Form } from 'formik';
import styled from 'styled-components/macro';
import { Button } from '@yme/atoms/button';
import { FormField } from '@yme/molecules/form-field';
import { colorCoreGray200 } from '@yme/tokens/colors';
import { CORNER_RADIUS } from '@yme/tokens/cornerRadius';
import { INDENT } from '@yme/tokens/sizes';
export const CertificateCodeInputStyled = styled(FormField) `
  flex-grow: 4;
`;
export const PaymentRowStyled = styled.div `
  display: flex;
  flex-wrap: nowrap;
  gap: 8px;
  align-items: start;
  ${({ isActive }) => isActive && `background:${colorCoreGray200};`};
  padding: ${INDENT.xs};
  ${({ isVisibleAlert }) => isVisibleAlert &&
    `
    & > :first-child {
      flex: 4;
      width: auto;
    }
  `}
`;
export const FormStyled = styled(Form) `
  border-radius: 0 0 ${CORNER_RADIUS.s} ${CORNER_RADIUS.s};
  width: 100%;
  & > div {
    border: 0 none;
  }
  .active-last-payment + ${PaymentRowStyled} {
    border-radius: 0 0 ${CORNER_RADIUS.s} ${CORNER_RADIUS.s};
  }
`;
export const ButtonStyled = styled(Button) `
  border-radius: ${CORNER_RADIUS.xs};
  flex-grow: 1;
  margin-top: 28px;
`;
